/**
 * 1.9.1: LIVE (pulsing, at the live edge) or "−0:42 · Go live", lifted from the LivePlayer so the editor's source
 * window has the same button (live-edge.ts decides when it is at the edge).
 */
import { behindText } from './live-edge';

export function LiveEdgeButton({ atEdge, behind, onGoLive, className = '' }: { atEdge: boolean; behind: number; onGoLive: () => void; className?: string }) {
  return (
    <button type="button" className={`live-go ${atEdge ? 'at-edge' : ''} ${className}`.trim()} onClick={onGoLive} disabled={atEdge}
      title={atEdge ? 'Playing live' : 'Jump to live and follow it (End)'} data-testid="live-edge" data-at-edge={atEdge ? 'true' : 'false'}>
      <span className="live-dot" aria-hidden /> {atEdge ? 'LIVE' : `${behindText(behind)} · Go live`}
    </button>
  );
}
